import axios from "axios";

import {
  GET_GType,
  TOGGLE_RType,
  RESET_GType,
  LOADING
} from "../actionTypes";
import { DEV_APIS_URL } from "configurations";
import { adminTokenDev } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.get(
          `${DEV_APIS_URL}/gender-types`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_GType, payload: res.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = "", desc = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${DEV_APIS_URL}/gender-types`,
            { 
                "gender_code": `${name}`,
                "description": `${desc}`
            },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "", desc = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.put(
          `${DEV_APIS_URL}/gender-types`,
          {
            "id":id,
            "gender_code": `${name}`,
            "description": `${desc}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${DEV_APIS_URL}/gender-types/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_GType });
